import React from 'react';
import { MdEdit, MdDelete } from 'react-icons/md';
import { CustomMode } from './types';

interface ModeListItemProps {
    mode: CustomMode;
    modeName: string;
    onEdit: () => void;
    onDelete: () => void;
}

const ModeListItem: React.FC<ModeListItemProps> = ({
    mode,
    modeName,
    onEdit,
    onDelete
}) => {
    return (
        <div className="flex items-center justify-between bg-neutral-100 dark:bg-neutral-800 p-3 rounded-lg">
            <div className="flex-1">
                <div className="font-medium text-neutral-800 dark:text-neutral-200 mb-1">
                    {modeName}
                </div>
                <div className="text-sm text-neutral-600 dark:text-neutral-400">
                    {mode.description || "No description"}
                </div>
            </div>
            <div className="flex space-x-2">
                <button
                    onClick={onEdit}
                    className="p-1 text-neutral-600 dark:text-neutral-400 hover:text-neutral-800 dark:hover:text-neutral-200"
                >
                    <MdEdit size={16} />
                </button>
                <button
                    onClick={onDelete}
                    className="p-1 text-red-600 hover:text-red-800"
                >
                    <MdDelete size={16} />
                </button>
            </div>
        </div>
    );
};

export default ModeListItem;